'use client'
import { useEffect, useState } from 'react'

type TypeScrollStates = 'TOP' | 'SCROLLING_DOWN' | 'SCROLLING_UP'
type TypeScroll = {
  currentState: TypeScrollStates
  lastScroll: number
  getCurrentState: (currentScroll:number, maxHeight:number) => TypeScrollStates
}

type TypeScrollTrackerReturn = {
  scrollState: TypeScrollStates
  scrollOnTop: boolean
}

const SCROLL: TypeScroll = {
  currentState: 'TOP',
  lastScroll: 0,
  getCurrentState(currentScroll, maxHeight) {
    if (currentScroll < maxHeight) this.currentState = 'TOP'
    else {
      if (this.lastScroll < currentScroll) this.currentState = 'SCROLLING_DOWN'
      else if (this.lastScroll > currentScroll) this.currentState = 'SCROLLING_UP'
    }

    this.lastScroll = currentScroll
    return this.currentState
  }
}

export const useScrollTracker = (maxHeight: number = 60):TypeScrollTrackerReturn => {
  const [scrollState, setScrollState] = useState<TypeScrollStates>('TOP')
  const [scrollOnTop, setScrollOnTop] = useState(true)

  const trackScroll = () => {
    const currentScroll = window.scrollY
    const newIsOnTop = currentScroll < maxHeight
    const newState = SCROLL.getCurrentState(currentScroll, maxHeight)

    setScrollOnTop(current => current !== newIsOnTop ? newIsOnTop : current)
    setScrollState(current => current !== newState ? newState : current)
  }

  const debounceTrackScroll = () => requestAnimationFrame(trackScroll)

  useEffect(() => {
    window.addEventListener('scroll', debounceTrackScroll, { passive: true })
    return () => window.removeEventListener('scroll', debounceTrackScroll)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maxHeight])

  return { scrollState, scrollOnTop }
}
